import { setJwt } from '@/util/auth'
import { getDefaultStore } from 'jotai'
import { isLoggedInAtom } from '@/state'
import { fetchProgressFlags } from '@/util/progress'
import { queryClient } from '@/util/queryClient'

export async function auth() {
  await setJwt()
  // find the right destination here
  const store = getDefaultStore()
  store.set(isLoggedInAtom, true)
  localStorage.setItem('isLoggedIn', 'true')
}

export type ProgressFlags = {
  flags: number
}

export async function queryProgressFlags() {
  const flags = await queryClient.fetchQuery({
    queryKey: ['progress-flags'],
    queryFn: fetchProgressFlags,
    staleTime: Infinity,
  })
  return flags
}
